export default __webpack_public_path__ + "static/media/bID-1.0b0408de.png";